<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><em>Paris Under Water</em></p>
<p class="fpage"> </p>
<p class="image"><a id="page_ii"></a><img alt="image" src="OEBPS/images/f00ii-01.gif"/></p>
<p class="caption"><a id="fig2"></a><em>Map of the flooded area in January–February 1910</em>.</p>
<p class="fpage"> </p>
<h1 class="h1"><a id="page_iii"></a><a id="ttl"></a><em>Paris Under Water</em></h1>
<p class="stitle">HOW <em>the</em> CITY <em>of</em>  LIGHT<br/>SURVIVED <em>the</em><br/>GREAT FLOOD<br/><em>of</em> 1910</p>
<p class="author">JEFFREY H. JACKSON</p>
<p class="publisher"><img alt="image" src="OEBPS/images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230617063_01_tit.vue?44fdbcee